import React from "react";
import PortfolioConfigData from "config/portfolio-config.json";
import styles from "./../portfolioTablePie.module.scss";
import { useTranslation } from "react-i18next";
import { colorCharts } from "data/palettes";
import colorsStore from "shared/store/colorsStore";
import { formatItalianNumber } from "utils/formatUtils";
const FinecoTable = ({ dataObject }) => {
  const { t } = useTranslation();
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  if (!dataObject.data) {
    return null;
  }
  const total = Math.round(
    dataObject.data.reduce((sum, row) => sum + row.weight, 0),
  );
  const paletteArray =
    PortfolioConfigData.palettes[dataObject.configData.palette];
  return (
    <div className={styles.tableContainer}>
      <table className={styles.distributionTable}>
        <thead>
          <tr>
            <th>{dataObject.configData.label_table_left}</th>
            <th>{dataObject.configData.label_table_right}</th>
          </tr>
        </thead>
        <tbody>
          {dataObject.data.map((row, index) => {
            const colorIndex = index % paletteArray.length;
            const displayLabel = dataObject.configData.rows
              ? dataObject.configData.rows[row.label] || row.label
              : row.label;
            return (
              <tr key={index}>
                <td>
                  <div className={styles.tableSimpleTdContainer}>
                    {dataObject.configData.type !== "table_simple" && (
                      <div className={styles.colorBoxContainer}>
                        <span
                          className={styles.colorBox}
                          style={{
                            backgroundColor:
                              colorsConfig[
                                colorCharts[colorIndex % colorCharts.length]
                              ],
                          }}
                        />
                      </div>
                    )}
                    <div className={styles.tableSimpleTd}>
                      <span className={styles.tableValues}>{displayLabel}</span>
                    </div>
                  </div>
                </td>
                <td>
                  {row.label === "sharpe" ? (
                    <span className={styles.tableValues}>
                      {formatItalianNumber(row.weight, 3)}
                    </span>
                  ) : (
                    <span className={styles.tableValues}>
                      {formatItalianNumber(row.weight)}
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
          {dataObject.configData.type !== "table_simple" && (
            <tr>
              <td>
                <div className={styles.totalCopy}>{t("portfolio.totale")}</div>
              </td>
              <td>
                <span className={styles.totalCopy}>{formatItalianNumber(total, 0)}</span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FinecoTable;
